export const FETCH_SETTING_DETAIL = 'FETCH_SETTING_DETAIL';
export const FETCH_SETTING_DETAIL_SUCCESS = 'FETCH_SETTING_DETAIL_SUCCESS';
export const FETCH_SETTING_DETAIL_FAILURE = 'FETCH_SETTING_DETAIL_FAILURE';
export const UPDATE_SETTING_SUCCESS = 'UPDATE_SETTING_SUCCESS';
